document.addEventListener("DOMContentLoaded", function() {
  // タイトルタグのテキストを取得
  var titleText = document.title;

  // タイトルに「検索」が含まれているかチェック
  if (titleText.includes("検索")) {
    console.log("This is a search page. Page title will not be created.");
  } else {
    // 末尾の指定したテキストを削除
    var modifiedTitle = titleText.replace(" – 零下 - REIKA -", "");

    // タイトルタグのテキストを変更
    document.title = modifiedTitle;

    /* 2026-09-01: 見出し・パンくずの文言をコレクション名に変更。従来は og:title を読んでいたため、
       SEOタイトルを設定したコレクションでは「日本酒 商品一覧｜マイナス5℃管理の酒屋 零下 -REIKA-」
       のような検索結果用の文言が、そのまま画面の見出しとパンくずに出ていた。
       コレクション名とアイキャッチ有無は layout/theme.liquid が window.REIKA_COLLECTION で渡す。
       検索ページなど渡されない場面では、従来どおり og:title にフォールバックする。 */
    var collectionMeta = window.REIKA_COLLECTION || {};
    var metaTag = document.querySelector('meta[property="og:title"]');
    var pageTitle = collectionMeta.title || (metaTag ? metaTag.getAttribute("content") : "");

    // h1タグを作成し、テキストを設定
    var heading = document.createElement("h1");
    heading.textContent = pageTitle;

    // h1タグにクラスを付与
    heading.classList.add("custom-title-class", "page-width"); // 2026-08-27: 新SIでBoostの一覧が .page-width の内側余白を持つため、JS挿入分にも同じクラスを付けて左右を揃える

    /* 2026-09-01: アイキャッチにコレクション名が入っているページは見出しが二重になるため、
       アイキャッチありのコレクションでは h1 を視覚的にだけ隠す。HTMLには残るので、
       Google と読み上げソフトには従来どおり見出しとして伝わる（画像内の文字は読めないため）。
       アイキャッチに文字が入っていないコレクションは、下のリストに handle を足せば表示される。 */
    var ALWAYS_SHOW_TITLE = ["happy-doburoku", "sparkling"];
    if (collectionMeta.hasImage && ALWAYS_SHOW_TITLE.indexOf(collectionMeta.handle) === -1) {
      heading.classList.add("visually-hidden");
    }

    // パンくずリストを作成
    var breadcrumb = document.createElement("div");
    breadcrumb.classList.add("re-breadcrumb", "re-main-article__re-breadcrumb", "page-width");
    breadcrumb.innerHTML = `<a href="/">トップ</a> / ${pageTitle}`;

    // metaタグから description の content 属性の値を取得
    var descriptionMetaTag = document.querySelector('meta[name="description"]');
    var descriptionText = descriptionMetaTag ? descriptionMetaTag.getAttribute("content") : "";

    // pタグを作成し、descriptionテキストを設定
    var descriptionParagraph = document.createElement("p");
    // descriptionParagraph.textContent = descriptionText;

    // pタグにクラスを付与
    descriptionParagraph.classList.add("custom-description-class", "page-width");

    // パンくずリストとh1タグを挿入する親要素を取得
    var parentElement = document.querySelector(".boost-sd__filter-product-list");

    // 親要素が存在する場合、その前にパンくずリストとh1タグを挿入
    if (parentElement) {
      parentElement.insertAdjacentElement('beforebegin', breadcrumb);
      breadcrumb.insertAdjacentElement('afterend', heading);
      heading.insertAdjacentElement('afterend', descriptionParagraph);
    } else {
      console.error("Parent element not found.");
    }
  }
});

